<template>
	<v-list class="bookmarks-list">

		<v-list-item
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.card_id"
			class="bookmarks-list__item"
		>
			<v-list-item-content class="pa-4">
				<router-link
					style='width: 100%'
					class="bookmarks-list__item-link"
					:to="{
						name: 'posts-by-id',
						params: { id: resourceItem.thread_id },
						query: {
							enable_all_comments: resourceItem.allow_comments ? 1 : 0
						}
					}"
				>
					<div>
						<h5 class='bookmarks-list__item-title' v-if="resourceItem.thread_title">
							{{resourceItem.thread_title}}
						</h5>
						<p
							v-html="resourceItem.thread_text"
							class="bookmarks-list__item-text ma-0"
						/>
					</div>
					<Icon 
						type="chevron_right"
						:size="18"
						color="#9B9B9B"
					/>
				</router-link>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	name: 'BookmarkList',
	data () {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	}
}
</script>

<style lang="scss">
.bookmarks-list {
	background-color: transparent !important;

	&__item {
		background-color: #fff;
		margin-bottom: 8px;
		border-radius: 10px;

		&-link {
			text-decoration: none;
			display: flex;
			justify-content: space-between;
			flex-wrap: nowrap;
		}

		&-title {
			font-size: 16px;
			font-weight: 700;
			line-height: 19.5px;
			color: #4A4A4A;
			margin-bottom: 10px;
		}

		&-text {
			font-size: 14px;
			line-height: 17.07px;
			color: #4A4A4A;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;

			p {
				margin: 0 !important;
			}
		}
	}
}
</style>
